import { Entity } from "../../core/models/entity";

export class Language extends Entity {
    public IsoCode?: string;
    public Name?: string;
}
